"use client";

import clsx from "clsx";
import {useTranslation} from "react-i18next";
import Button from "@/components/library/Button";
import Icon from "@/components/library/Icon";
import FinishSetupSection from "./FinishSetupSection";
import GetStartedCardsGrid from "./GetStartedCardsGrid";
import JumpInWithGailSection from "./JumpInWithGailSection";

interface EmptyStateDashboardProps {
   onViewDashboard?: () => void;
   onResetOnboarding?: () => void;
}

export default function EmptyStateDashboard({
   onViewDashboard,
   onResetOnboarding,
}: Readonly<EmptyStateDashboardProps>) {
   const {t} = useTranslation("stats");

   return (
      <div className={clsx("flex", "flex-col", "gap-8")}>
         <GetStartedCardsGrid />
         <div className={clsx("grid", "grid-cols-1", "xl:grid-cols-2", "gap-8")}>
            <FinishSetupSection />
            <JumpInWithGailSection maxCards={6} />
         </div>
         <div className="flex items-center gap-4">
            {onViewDashboard && (
               <Button type="secondary" className="mt-4" onClick={onViewDashboard}>
                  {t("emptyState.viewDashboard")}
               </Button>
            )}
            {onResetOnboarding && (
               <button
                  type="button"
                  onClick={onResetOnboarding}
                  className={clsx(
                     "mt-4 flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium rounded-lg",
                     "border border-destructive/30 text-destructive",
                     "hover:bg-destructive/10 transition-colors"
                  )}
               >
                  <Icon icon="arrow-rotate-left" className="w-3 h-3" />
                  Reset Onboarding
               </button>
            )}
         </div>
      </div>
   );
}
